import { Stack } from '@mui/material'
import { ShowMore, TinyButton, tokens, type User } from 'ComponentLibrary'
import { TaskListPreviewItem } from 'ComponentLibrary/src/widgets/TaskListPreview/TaskListPreviewItem'
import { Task } from 'ComponentLibrary/src/common/tasks'
import { PlusIcon } from '@phosphor-icons/react'
import { Typography } from 'ComponentLibrary/src/piazza/text'
import { type UserLinkCopy } from 'ComponentLibrary/src/piazza/text/UserLink/UserLink'

type TaskListPreviewProps = {
    onItemClick: (task: Task) => void
    tasksDone: Task[]
    activeTasks: Task[]
    numberOfTasks: number
    users?: User[]
    onClickAddTask?: () => void
    emptyStateText?: string
    copy?: Partial<TaskListPreviewCopy>
    userLinkCopy?: Partial<UserLinkCopy>
}

export type TaskListPreviewCopy = {
    createTask: string
    statusLabels: Record<Task['status'], string>
    showMore: string
    showLess: string
}

const DEFAULT_TASK_LIST_PREVIEW_COPY: TaskListPreviewCopy = {
    createTask: 'Aufgabe erstellen',
    statusLabels: {
        open: 'Offen',
        done: 'Abgeschlossen',
    },
    showMore: 'Mehr anzeigen...',
    showLess: 'Weniger anzeigen',
}

export const TaskListPreview = ({
    onItemClick,
    tasksDone,
    activeTasks,
    numberOfTasks,
    users,
    onClickAddTask,
    emptyStateText,
    copy,
    userLinkCopy,
}: TaskListPreviewProps) => {
    const resolvedCopy = { ...DEFAULT_TASK_LIST_PREVIEW_COPY, ...copy }
    const sortedTasks = [...activeTasks, ...tasksDone]

    return (
        <Stack direction="column">
            {numberOfTasks === 0 && onClickAddTask && (
                <Stack direction="column" gap={tokens.SizingSpacing200}>
                    {emptyStateText && (
                        <Typography variant="textS" color={tokens.ColorTextDefault}>
                            {emptyStateText}
                        </Typography>
                    )}
                    <TinyButton onClick={onClickAddTask} label={resolvedCopy.createTask} leftIcon={<PlusIcon />} />
                </Stack>
            )}
            <ShowMore threshold={4} gap={4} showMoreLabel={resolvedCopy.showMore} showLessLabel={resolvedCopy.showLess}>
                {sortedTasks.map((task) => (
                    <TaskListPreviewItem
                        key={task.uuid}
                        task={task}
                        users={users}
                        onClick={onItemClick}
                        userLinkCopy={userLinkCopy}
                        statusLabels={resolvedCopy.statusLabels}
                    />
                ))}
            </ShowMore>
        </Stack>
    )
}
